import { render, staticRenderFns } from "./ListSimple.vue?vue&type=template&id=1f3283fe&"
import script from "./ListSimple.vue?vue&type=script&lang=js&"
export * from "./ListSimple.vue?vue&type=script&lang=js&"
import style0 from "./ListSimple.vue?vue&type=style&index=0&id=1f3283fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports